var map = {
	"./badge-talentech/badgeTalentech.dist.js": "cfac",
	"./filters-talentech/filtersTalentech.dist.js": "f55a",
	"./input-talentech/inputTalentech.dist.js": "be65",
	"./tabs-talentech/tabsTalentech.dist.js": "a132",
	"./talmundo-chatbot/talmundoChatbot.dist.js": "e3c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b66";